import store from "@/store";

export const removeUnusedEvents = (fanzone, scenes) => {
  fanzone.doc.events = [...fanzone.doc.events.filter(e => scenes.includes(e.sceneName))]
  return fanzone
}

export const getFormData = (fanzone) => {
  let formData = new FormData()

  formData.append('id', fanzone.id)
  formData.append('idx', fanzone.idx)
  formData.append('fanzine_status', fanzone.fanzine_status)
  formData.append('fanzine_type', fanzone.fanzine_type)
  formData.append('fanzine_visibility', fanzone.fanzine_visibility)

  if (typeof fanzone.image === 'object') formData.append('image', fanzone.image)
  if (typeof fanzone.image_logo === 'object') formData.append('image_logo', fanzone.image_logo)
  if (typeof fanzone.image_map === 'object') formData.append('image_map', fanzone.image_map)
  if (typeof fanzone.image_background === 'object') formData.append('image_background', fanzone.image_background)
  if (typeof fanzone.image_nav === 'object') formData.append('image_nav', fanzone.image_nav)        

  formData.append('doc', JSON.stringify(fanzone.doc))

  return formData
}

export const handleUpdateFanzone = (fanzone) => {
  store.dispatch('updateFanzone', { fanzone })
}

export const handleSimplePropChanged = (key, value) => {
  store.dispatch('setSimpleProp', { key, value })
}

export const handleSimplePropWithLocaleChanged = (key, value, locale) => {
  store.dispatch('setSimplePropWithLocale', { key, value, locale })
}

export const handleNestedPropChanged = (keys, value) => {
  store.dispatch('setNestedProp', { keys, value })
}

export const handleSimpleArrayItemChanged = (key, idx, value) => {
  store.dispatch('setSimpleArrayItem', { key, idx, value })
}

export const handleSimpleArrayOfObjectItemChanged = (key, idx, objKey, value) => {
  store.dispatch('setSimpleArrayOfObjectItem', { key, idx, objKey, value })
}

export const handleAddEvent = (date, scene) => {
  store.dispatch('addEvent', { date, scene })
}

export const handleAddMarker = (name, categoryId, lat, lon) => {
  store.dispatch('addMarker', { name, categoryId, lat, lon })
}

export const handleAddArtistsCategory = (name) => {
  store.dispatch('addArtistsCategory', { name })
}

export const handleAddMarkersCategory = (name) => {
  store.dispatch('addMarkersCategory', { name })
}

export const handleFillForm = (fanzone) => {
  store.dispatch('fillForm', { fanzone })
}

export const handleFillArtistForm = (artistId) => {
  store.dispatch('fillArtistForm', { artistId })
}

export const handleRemoveArrayItem = (key, idx) => {
  store.dispatch('removeArrayItem', { key, idx })
}

export const handleEditMarker = (marker, field, value, locale=null) => {
  console.log('0000')
  store.dispatch('editMarker', { marker, field, value, locale })
}

export const handleEditMarkerCategory = (category, field, value, locale=null) => {
  store.dispatch('editMarkerCategory', { category, field, value, locale })
}

export const handleRemoveMarker = (marker) => {
  store.dispatch('removeMarker', { marker })
}

export const handleRemoveArtistsCategory = (category) => {
  store.dispatch('removeArtistsCategory', { category })
}

export const handleRemoveMarkerCategory = (category) => {
  store.dispatch('removeMarkerCategory', { category })
}

export const handleAddFlatPage = () => {
  store.dispatch('addFlatPage')
}

export const handleFlatPageTitleChanged= (flatPageId, value, locale) => {
  store.dispatch('flatPageTitleChanged', { flatPageId, value, locale })
}

export const handleFlatPageLinkChanged= (flatPageId, value, locale) => {
  store.dispatch('flatPageLinkChanged', { flatPageId, value, locale })
}

export const handleAddFlatPageItem = (flatPageId, itemType) => {
  store.dispatch('addFlatPageItem', { flatPageId, itemType })
}

export const handleItemTextValueChanged = (flatPageId, itemId, value, locale) => {
  store.dispatch('itemTextValueChanged', { flatPageId, itemId, value, locale })
}

export const handleRemoveFlatPageItem = (flatPageId, itemId) => {
  store.dispatch('removeFlatPageItem', { flatPageId, itemId })
}

export const handleClickMoveUpFlatPageItem = (flatPageId, itemId) => {
  store.dispatch('moveUpFlatPageItem', { flatPageId, itemId })
}

export const handleClickMoveDownFlatPageItem = (flatPageId, itemId) => {
  store.dispatch('moveDownFlatPageItem', { flatPageId, itemId })
}

export const handleItemImageValueChanged = (flatPageId, itemId, value) => {
  store.dispatch('itemImageValueChanged', { flatPageId, itemId, value })
}

export const handleRemoveFlatPage = (flatPageId) => {
  store.dispatch('removeFlatPage', { flatPageId })
}

export const handleItemTextStyleChanged = (flatPageId, itemId, key, value) => {
  store.dispatch('itemTextStyleChanged', { flatPageId, itemId, key, value })
}

export const handleItemYoutubeValueChanged = (flatPageId, itemId, key, value) => {
  store.dispatch('itemYoutubeValueChanged', { flatPageId, itemId, key, value })
}

export const handleAddMapMarker = (flatPageId, itemId) => {
  store.dispatch('addMapMarker', { flatPageId, itemId })
}

export const handleMapMarkerChanged = (flatPageId, itemId, markerId, key, value) => {
  store.dispatch('mapMarkerChanged', { flatPageId, itemId, markerId, key, value })
}

export const handleRemoveMapMarker = (flatPageId, itemId, markerId) => {
  store.dispatch('mapMarkerRemoved', { flatPageId, itemId, markerId })
}

export const handleFlatPagePropChanged = (flatPageId, key, value) => {
  store.dispatch('flatPagePropChanged', { flatPageId, key, value })
}

export const handleItemBannerValueChanged = (flatPageId, itemId, key, value) => {
  store.dispatch('itemBannerValueChanged', { flatPageId, itemId, key, value })
}

export const handleItemBannerStyleChanged = (flatPageId, itemId, field, key, value) => {
  store.dispatch('itemBannerStyleChanged', { flatPageId, itemId, field, key, value })
}

export const handleSetData = (key, value) => {
  store.dispatch('setData', { key, value })
}

export const handleFileUpload = (key, value) => {
  store.dispatch('fileUploaded', { key, value })
}

export const handleAddImageToList = (flatPageId, itemId) => {
  store.dispatch('addImageToList', { flatPageId, itemId })
}

export const handleRemoveImageFromList = (flatPageId, itemId, imageId) => {
  store.dispatch('removeImageFromList', { flatPageId, itemId, imageId })
}

export const handleMoveImageLeftInImageList = (flatPageId, itemId, imageId) => {
  store.dispatch('moveImageLeftInImageList', { flatPageId, itemId, imageId })
}

export const handleMoveImageRightInImageList = (flatPageId, itemId, imageId) => {
  store.dispatch('moveImageRightInImageList', { flatPageId, itemId, imageId })
}

export const handleChangeImageInList = (flatPageId, itemId, imageId, value) => {
  store.dispatch('changeImageInList', { flatPageId, itemId, imageId, value })
}

export const handleArtistImageUpload = (key, value) => {
  store.dispatch('artistImageUploaded', { key, value })
}

export const handleEventPropChanged = (event, key, value) => {
  store.dispatch('eventPropChanged', { event, key, value })
}

export const handleSaveArtist = (form) => {
  store.dispatch('saveArtist', form)
}

export const handleSetArtistData = (key, value) => {
  store.dispatch('setArtistData', { key, value })
}

export const handleImageListImagePropChanged = (flatPageId, itemId, imageId, key, value) => {
  store.dispatch('imageListImagePropChanged', { flatPageId, itemId, imageId, key, value })
}

export const handleImageListValueChanged = (flatPageId, itemId, imageId, key, value) => {
  store.dispatch('imageListValueChanged', { flatPageId, itemId, key, value })
}

export const handleItemImageLinkChanged = (flatPageId, itemId, value) => {
  store.dispatch('itemImageLinkChanged', { flatPageId, itemId, value })
}

export const handleAddDate = () => {
  store.dispatch('addDate')
}

export const handleRemoveDate = (dateId) => {
  store.dispatch('removeDate', { dateId })
}

export const handleClickMoveUpFlatPage = (flatPageId) => {
  store.dispatch('moveUpFlatPage', { flatPageId })
}

export const handleClickMoveDownFlatPage = (flatPageId) => {
  store.dispatch('moveDownFlatPage', { flatPageId })
}

export const handleAddScene =  (name) => {
  store.dispatch('addScene', { name })
}

export const handleAddDay =  (day) => {
  store.dispatch('addDay', { day })
}

export const handleAddSceneDate =  (scene, day) => {
  store.dispatch('addSceneDate', { scene, day })
}

export const handleAddEventToScene =  (scene, day) => {
  store.dispatch('addEventToScene', { scene, day })
}

export const handleRemoveItemFromArray =  (arrayObj, keyName, item) => {
  store.dispatch('removeItemFromArray', { arrayObj, keyName, item })
}

export const handleAddFaqElementToList = (flatPageId, itemId) => {
  store.dispatch('addFaqElementToList', { flatPageId, itemId })
}

export const handleMoveUpScene =  (idx) => {
  store.dispatch('moveUpScene', { idx })
}

export const handleMoveDownScene =  (idx) => {
  store.dispatch('moveDownScene', { idx })
}
